<script setup lang="ts">
import type { IPublication } from '@/entities/publication/model/types/publication';

withDefaults(defineProps<{ data?: IPublication[] }>(), {
  data: () => [],
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['editor-publications-section', { _mobile: isMobile }]">
    <div class="editor-publications-section__title">Публикации и упоминания</div>
    <ul class="editor-publications-section__list">
      <li v-for="item in data" :key="item.id" class="editor-publications-section__item">
        <a
          class="editor-publications-section__link"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppIcon class="editor-publications-section__icon" name="Link" />
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.editor-publications-section {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    font-size: 30px;
    font-weight: 700;
    line-height: 130%;
  }

  &__list {
    .flex-column(@size-x5);
  }

  &__link {
    .color-change-hover();
    .underline-hover();

    display: inline-flex;
    align-items: center;
    gap: @size-x2;
    font-size: @size-x4;
    line-height: 130%;
    font-weight: 500;
    color: @color-persimmon;
  }

  &__icon {
    flex-shrink: 0;
    width: @size-x4;
    height: @size-x4;

    path {
      fill: @color-persimmon;
    }
  }

  &._mobile {
    padding: @size-x6;
  }
}
</style>
